import { render, staticRenderFns } from "./FoodModifier.vue?vue&type=template&id=09ad02d3&"
import script from "./FoodModifier.vue?vue&type=script&lang=js&"
export * from "./FoodModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports